import { Box, Skeleton, Typography } from '@myn/mui';

const StatusBarSkeleton: React.FC = () => (
  <Box sx={{ display: 'flex', gap: '4px', height: '16px' }}>
    <Typography variant="label01" color="text.secondary">
      Approval status:
    </Typography>
    <Box sx={{ display: 'flex', gap: '12px' }}>
      <Skeleton variant="rounded" width={84} height={16} />
      <Skeleton variant="rounded" width={84} height={16} />
    </Box>
  </Box>
);
export default StatusBarSkeleton;
